import React from 'react';
import { Tooltip as UniTooltip, TooltipProps as UniTooltipProps } from '@planne-software/uni/Tooltip';
import { StyledScopedCssBaseline } from './styles';

interface TooltipProps extends UniTooltipProps {
  showContent?: boolean;
}

export const Tooltip = (props: TooltipProps) => {
  const { showContent, children, ...rest } = props;

  if (!showContent) {
    return children;
  }

  return (
    <StyledScopedCssBaseline>
      <UniTooltip {...rest}>{children}</UniTooltip>
    </StyledScopedCssBaseline>
  );
};
